 <fury-page>
  <fury-title class="title">
    <span [@fadeInRight]>{{userId ? 'Update' : 'Add'}} User</span>
  </fury-title>
</fury-page>
<div fxLayout="column" fxLayoutAlign="start center">
  <div [@fadeInUp] class="card">
    <form [formGroup]="userForm">
      <div class="content" fxLayout="column" fxLayoutGap="8px">
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput placeholder="First Name" (keyup)="restrictSpace($event)" formControlName="firstName">
            <mat-error *ngIf="userForm.controls['firstName'].touched && userForm.controls['firstName'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput placeholder="Last Name" formControlName="lastName" (keyup)="restrictSpace($event)">
            <mat-error *ngIf="userForm.controls['lastName'].touched && userForm.controls['lastName'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field   fxFlex="auto" appearance="outline">
            <mat-label>Role</mat-label>
            <mat-select  formControlName="roleId"  (ngModelChange)="onChangeRole($event)" [multiple]="!isExternalUser"  [disabled]="isClaimRole || isPartnerRole">
              <mat-option *ngFor="let role of adminTypeList" [value]="role?.roleId">{{role?.title}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.controls['roleId'].touched && userForm.controls['roleId'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
        
            <mat-form-field fxFlex="auto" appearance="outline" *ngIf="subRoles.length > 0">
              <mat-label>Sub Role</mat-label>
              <mat-select formControlName="subRoleId" multiple  (ngModelChange)="onChangeSubRole($event)">
                <mat-option *ngFor="let role of subRoles" [value]="role?.roleId">{{role?.title}} - {{role?.parent?.title}}</mat-option>
              </mat-select>
              <mat-error *ngIf="userForm.controls['subRoleId'].touched && userForm.controls['subRoleId'].hasError('required')">
                This is a required field.</mat-error>

                <mat-error *ngIf="userForm.controls['subRoleId'].hasError('invalid')">
                  You must select at least one sub role from each selected role.</mat-error>
            </mat-form-field>     
      
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Email Id</mat-label>
            <input matInput placeholder="Email Id" formControlName="emailAddress">
            <mat-error *ngIf="userForm.controls['emailAddress'].touched && userForm.controls['emailAddress'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="userForm.controls['emailAddress'].touched && userForm.controls['emailAddress'].hasError('pattern')">
                    Please enter a valid email id.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input type="text" matInput placeholder="Phone Number" formControlName="phoneNumber" mask="(000) 000-0000">
            <mat-error *ngIf="userForm.controls['phoneNumber'].touched && userForm.controls['phoneNumber'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="userForm.controls['phoneNumber'].touched && userForm.controls['phoneNumber'].hasError('pattern')">
                    Please enter a valid phone number.</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline" *ngIf="!isSelectedPartner">
            <mat-label>Password</mat-label>
            <input [type]="hide ? 'password' : 'text'" matInput placeholder="Password" formControlName="password"  autocomplete="new-password">
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="userForm.controls['password'].touched && userForm.controls['password'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="userForm.controls['password'].touched && userForm.controls['password'].hasError('pattern')">
                    Please enter strong password.</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
           
          <mat-form-field fxFlex="auto" appearance="outline"  *ngIf="(isSelectedClaim && userForm.controls['roleId'].value?.length > 1 ) || (!isSelectedClaim)">
            <mat-label>Attempts</mat-label>
            <input type ='text' matInput placeholder="Attempts" formControlName="attempts" (keypress)="apiService.allowNumbers($event)" min="0">
            <mat-error *ngIf="userForm.controls['attempts'].touched && userForm.controls['attempts'].hasError('required')">
                This is a required field.
            </mat-error>
            <mat-error *ngIf="userForm.controls['attempts'].touched && userForm.controls['attempts'].hasError('min')">
              Minimum value should be 0.
          </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline" *ngIf="isSelectedClaim">
            <mat-label>Add/Subtract Credit Leaves</mat-label>
            <input type ='text' matInput placeholder="Credit Leaves" formControlName="manualCreditScore" mask="separator.1" [allowNegativeNumbers]="true">
            <mat-error *ngIf="userForm.controls['manualCreditScore'].touched && userForm.controls['manualCreditScore'].hasError('required')">
                This is a required field.
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Start Time</mat-label>
            
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="friStart"
            [format]="24"
            readonly
            formControlName="startTime"
          />
          <ngx-mat-timepicker
          #friStart
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!scheduleFormControlItem.disabled"
            (click)="openFromIcon(friStart)"
            >schedule</mat-icon
          >
          <mat-error *ngIf="userForm.controls['startTime'].touched && userForm.controls['startTime'].hasError('required')">
            This is a required field.
          </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>End Time</mat-label>
            
            <input
            type="text"
            matInput
            [ngxMatTimepicker]="endTime"
            [format]="24"
            readonly
            formControlName="endTime"
          />
          <ngx-mat-timepicker
          #endTime
          [enableKeyboardInput]="true">
        </ngx-mat-timepicker>
        
          <mat-icon
            matSuffix
            *ngIf="!scheduleFormControlItem.disabled"
            (click)="openFromIcon(endTime)"
            >schedule</mat-icon
          >
          <mat-error *ngIf="userForm.controls['endTime'].touched && userForm.controls['endTime'].hasError('required')">
            This is a required field.
          </mat-error>
          </mat-form-field>
        </div>

        <div fxLayout="column"  fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px"  *ngIf="isSelectedPartner">

          <mat-form-field fxFlex="auto" appearance="outline" >
            <mat-label>Lead Sources</mat-label>
            <mat-select formControlName="leadSources" multiple>
              <mat-option *ngFor="let lead of leadSources" [value]="lead">{{lead}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userForm.controls['leadSources'].touched && userForm.controls['leadSources'].hasError('required')">
              This is a required field.</mat-error>
          </mat-form-field>
  
          <mat-form-field fxFlex="auto" appearance="outline">
            <mat-label>Excluded Lead Statuses</mat-label>
            <mat-select formControlName="excludeLeadStatuses" multiple>
              <mat-option *ngFor="let lead of excludeLeadStatusesOptions" [value]="lead">{{lead}}</mat-option>
            </mat-select>

          </mat-form-field>
  
          <mat-form-field fxFlex="auto" appearance="outline" >
            <mat-label>Excluded States</mat-label>
            <mat-select formControlName="excludeStates" multiple>
              <mat-option *ngFor="let state of stateList" [value]="state?.abbreviation">{{state?.title}}</mat-option>
            </mat-select>
          </mat-form-field>
          </div>

        <div class="flex">
          <div *ngIf="!isSelectedPartner">
            <mat-slide-toggle formControlName="editorAccess" >Editor Access</mat-slide-toggle>
          </div>
    
          <div  *ngIf="isSelectedClaim">
            <mat-slide-toggle formControlName="isActive">Active User</mat-slide-toggle>
          </div>
  
          <div *ngIf="isSelectedPartner">
            <mat-slide-toggle formControlName="onlineAccess" >Online Access</mat-slide-toggle>
          </div>

          <div *ngIf="isSelectedPartner">
            <mat-slide-toggle formControlName="excludeBadLead" >Exclude Bad Lead</mat-slide-toggle>
          </div>
          <div *ngIf="isSelectedPartner">
            <mat-slide-toggle formControlName="excludeDuplicateLead" >Exclude Duplicate Lead</mat-slide-toggle>
          </div>
          <div *ngIf="isSelectedPartner">
            <mat-slide-toggle formControlName="excludeRestrictedLead" >Exclude Restricted Lead</mat-slide-toggle>
          </div>
          <div *ngIf="isSelectedPartner">
            <mat-slide-toggle formControlName="excludeFlagLead" >Exclude Flag Lead</mat-slide-toggle>
          </div>
          <div *ngIf="!isExternalUser">
            <mat-slide-toggle formControlName="bypassIpAddress">Bypass Ip Address</mat-slide-toggle>
          </div>
          <div>
            <mat-slide-toggle formControlName="specialAccess">Special Access</mat-slide-toggle>
          </div>
        </div>
  

        <div *ngIf="isSelectedClaim" class="full_check">
         <h2>Working Days of Claim User : </h2> 
          <div class="tabPrt">
            <fury-time-scheduler-tab [scheduleData]="workingDaysData" (timeSchedulePayload)="getTimeSchedulePayload($event)"></fury-time-scheduler-tab> 
          </div>
          
        </div>

        <div class="content" fxLayout="column" fxLayoutGap="8px" *ngIf="!isExternalUser && !userForm.controls['bypassIpAddress'].value">
          <div formArrayName="accessedIp">
   <div *ngFor="let item of ipAddress.controls; let i = index">
       <div class="answerprt">
           <mat-form-field appearance="outline">
             <mat-label>Ip Address</mat-label>
             <input
               matInput
               placeholder="Enter Ip Address"
               formControlName="{{i}}"
             />
             <mat-error *ngIf="item.hasError('required')">
               This is a required field.
             </mat-error>
             <mat-error *ngIf="item.hasError('pattern')">
               Please enter valid ip address.
             </mat-error>
           </mat-form-field>
           <span
         (click)="removeField(i)"
         *ngIf="ipAddress.controls.length > 1"
         class="remove"><mat-icon>clear</mat-icon></span>
         </div>
   </div>
   <button
     type="button"
     mat-raised-button
     (click)="addField()"
     [disabled]="
       userForm?.controls?.accessedIp?.status === 'INVALID'
     "
   >
    <mat-icon>add_circle_outline</mat-icon> Add New Ip Address
   </button>
          </div>
        </div>
      
      </div>
      <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
        <button (click)="addEditUser()" class="sub-button" mat-button type="button" [disabled]="isLoading">{{userId ? 'Update' : 'Add'}}</button>
        <button class="can-button" type="button" (click)="this.location.back()" mat-button [disabled]="isLoading">Cancel</button>
      </div>
     
    </form>
  </div>
</div>

